
export const GET_CLAIM="GET_CLAIM"

export const GET_CLAIM_REQUEST="GET_CLAIM_REQUEST"
export const GET_CLAIM_SUCCESS="GET_CLAIM_SUCCESS"
export const GET_CLAIM_FAILUER="GET_CLAIM_FAILUER"